import React, {forwardRef} from 'react'

import cn from 'classnames/bind'

import Radio, {IRadioProps} from 'components/elements/fields/Radio/Radio'

import s from './RadioGroup.module.scss'

const cx = cn.bind(s)

export interface IRadioGroupProps extends IRadioProps {
	name: string
	storeValue: string
	options: readonly {
		value: string | number
		name?: string
	}[]
}

const RadioGroup = forwardRef<HTMLInputElement, IRadioGroupProps>(
	({name, label, storeValue, onChange, options, ...props}, ref) => {
		return (
			<div className={cx('group')}>
				<div className={cx('group__label')}>{label}</div>

				<div className={cx('group__inputs')}>
					{options.map(({value, name: optionName}) => (
						<Radio
							{...props}
							ref={ref}
							key={value}
							label={optionName}
							value={value}
							checked={storeValue === value}
							name={name}
							onChange={onChange}
						/>
					))}
				</div>
			</div>
		)
	},
)

RadioGroup.displayName = 'RadioGroup'

export default RadioGroup
